// apps/web/src/services/api-client.ts
//
// Singleton Hono RPC client. `setApiBaseUrl` is called by the runtime
// env loader. Mutating a shared `params` object keeps the SAME client
// instance across `?setEnv` switches.

import { hc } from 'hono/client';

import type { AppType } from 'breeze-api/handlers/api.handler';

const params = { basePath: '' };

export const api = hc<AppType>('', {
  fetch: (input: RequestInfo | URL, init?: RequestInit) =>
    fetch(`${params.basePath}${String(input)}`, { ...init, credentials: 'include' }),
});

export function setApiBaseUrl(url: string): void {
  params.basePath = url;
}

export function getApiBaseUrl(): string {
  return params.basePath;
}
